

                if (!window.beaePageJS) {
                    window.beaePageJS = [];
                }
                let jsHandle_bdajw0ti3h = () => {
                    
                        if (document.querySelector('.beae-el4t736b:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-el4t736b:not([data-beae-bind])'),
                                
                                id: 'beae-el4t736b',
                                isLive: true
                            });
                            document.querySelector('.beae-el4t736b:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-k7ex84s0:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-k7ex84s0:not([data-beae-bind])'),
                                
                                id: 'beae-k7ex84s0',
                                isLive: true
                            });
                            document.querySelector('.beae-k7ex84s0:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-6sfv8epe:not([data-beae-bind])')) {
                            (function() {if(!this.isLive)return;let e=window.innerWidth,t=()=>{this.$el&&this.$el.querySelector(".beae-section-background-video")&&typeof handleVideoBg<"u"?(handleVideoBg.bind(this)(),window.addEventListener("resize",()=>{window.innerWidth!=e&&(e=window.innerWidth,handleVideoBg.bind(this)())})):setTimeout(()=>t(),500)};t()}).call({
                                $el: document.querySelector('.beae-6sfv8epe:not([data-beae-bind])'),
                                
                                id: 'beae-6sfv8epe',
                                isLive: true
                            });
                            document.querySelector('.beae-6sfv8epe:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                        if (document.querySelector('.beae-esdkwrv2:not([data-beae-bind])')) {
                            (function() {let e=this.$el.querySelector(".beae-shopify__article__description-view-more-btn"),t=this.settings.content_type,a=this.$el.querySelector(".beae-shopify__article__description--full"),n=this.$el.querySelector(".beae-shopify__article__description--paragraph");e&&e.addEventListener("click",function(){t==="text"&&a?(a.style.display="inherit",n.style.display="none"):n.style.maxHeight=null,this.style.display="none"})}).call({
                                $el: document.querySelector('.beae-esdkwrv2:not([data-beae-bind])'),
                                settings: {"content_type":"html"},
                                id: 'beae-esdkwrv2',
                                isLive: true
                            });
                            document.querySelector('.beae-esdkwrv2:not([data-beae-bind])').setAttribute('data-beae-bind', true);
                        }
                
                }
                if (window.beaejQuery) {
                    jsHandle_bdajw0ti3h()
                } else {
                    window.beaePageJS.push(jsHandle_bdajw0ti3h)
                }
            